import styled from '@emotion/styled'

export const CropperContainer = styled.div`
  width: 100%;
  padding-top: 2rem;
`
